import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BcmApiService } from './bcm-api.service';
import { parseHttpResponseList, parseHttpResponseItem } from '../../../../../@shared/functions/parse-http-response';
import { IReadingRaw, Reading } from '../../../../../@shared/models/electric-meter-reading';

@Injectable({
    providedIn: 'root'
})
export class ElectricMeterReadingApiService extends BcmApiService {

    /**
     * ToDO: Check, if all methods are needed or if readonly (get only) is enough
     */

    private RESOURCE_ENDPOINT = 'electric-meter-readings';

    getAll(params: HttpParams = new HttpParams()): Observable<Reading[]> {
        return super.get<IReadingRaw[]>(this.RESOURCE_ENDPOINT, params)
            .pipe(parseHttpResponseList<IReadingRaw, Reading>(Reading));
    }

    getOne(id: number, params: HttpParams = new HttpParams()): Observable<Reading> {
        return super.get<IReadingRaw>(`${this.RESOURCE_ENDPOINT}/${id}`, params)
            .pipe(parseHttpResponseItem<IReadingRaw, Reading>(Reading));
    }

    // add(body: object = {}): Observable<number> {
    //     return super.put(this.RESOURCE_ENDPOINT, body);
    // }
    //
    // updateSection(id: number, body: object = {}): Observable<number> {
    //     return super.put(`${this.RESOURCE_ENDPOINT}/${id}`, body);
    // }
    //
    // remove(id: number): Observable<number> {
    //     return super.delete(`${this.RESOURCE_ENDPOINT}/${id}`);
    // }
}
